import type { SVGProps } from 'react';

const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2M20 11h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1M6 12c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1M12 18c-.55 0-1 .45-1 1v1c0 .55.45 1 1 1s1-.45 1-1v-1c0-.55-.45-1-1-1M12 6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v1c0 .55.45 1 1 1M17.66 16.24a.996.996 0 1 0-1.41 1.41l.71.71c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.71-.71zM6.34 7.76c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.71-.71a.996.996 0 1 0-1.41 1.41l.71.71zM6.34 16.24l-.71.71a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l.71-.71a.996.996 0 1 0-1.41-1.41zM16.95 8.05c.26 0 .51-.1.71-.29l.71-.71a.996.996 0 1 0-1.41-1.41l-.71.71a.996.996 0 0 0 .71 1.7z"
    />
  </svg>
);
export default SvgSun;
